export default __webpack_public_path__ + "static/media/bell.b63b7862.svg";